<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Agência</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <!-- Identificação -->
                      <div class="form-group col-md-4">
                        <label> <span class="required">*</span> Nome: </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="entity.name"
                          placeholder=""
                        />
                      </div>

                      <div class="form-group col-md-4">
                        <label>
                          <span class="required">*</span> Nome Fantasia:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="entity.fantasy_name"
                          placeholder=""
                        />
                      </div>

                      <div class="form-group col-md-4">
                        <label> <span class="required">*</span> CNPJ: </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="entity.cnpj"
                          placeholder=""
                          v-mask="'99.999.999/9999-99'"
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <!-- Contato -->
                      <div class="form-group col-md-4">
                        <label> <span class="required">*</span> E-mail: </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="entity.email"
                          placeholder=""
                        />
                      </div>

                      <div class="form-group col-md-4">
                        <label> Telefone: </label>
                        <input
                          autocomplete="new-password"
                          type="tel"
                          class="form-control"
                          v-model="entity.telphone"
                          placeholder=""
                          v-mask="'(99) 9999-9999'"
                        />
                      </div>

                      <div class="form-group col-md-4">
                        <label> Celular: </label>
                        <input
                          autocomplete="new-password"
                          type="tel"
                          class="form-control"
                          v-model="entity.celphone"
                          placeholder=""
                          v-mask="'(99) 99999-9999'"
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <!-- Endereço -->
                      <div class="form-group col-md-2">
                        <label> <span class="required">*</span> CEP: </label>
                        <input
                          autocomplete="new-password"
                          type="tel"
                          class="form-control"
                          v-model="entity.cep"
                          placeholder=""
                          v-on:keyup="buscar"
                          v-mask="'99999-999'"
                        />
                      </div>

                      <div class="form-group col-md-4">
                        <label>
                          <span class="required">*</span> Endereço:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="entity.street"
                          placeholder=""
                        />
                      </div>

                      <div class="form-group col-md-3">
                        <label> <span class="required">*</span> Bairro: </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="entity.neighborhood"
                          placeholder=""
                        />
                      </div>

                      <div class="form-group col-md-3">
                        <label> <span class="required">*</span> Número: </label>
                        <input
                          autocomplete="new-password"
                          type="number"
                          class="form-control"
                          v-model="entity.number"
                          placeholder=""
                          id="inputnumber"
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-3">
                        <label> Complemento: </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="entity.complement"
                          placeholder=""
                        />
                      </div>

                      <div class="form-group col-md-3">
                        <label> <span class="required">*</span> CNES: </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="entity.cnes"
                          placeholder=""
                        />
                      </div>

                      <div class="form-group col-md-3">
                        <label> <span class="required">*</span> Estado: </label>
                        <input
                          v-model="entity.uf"
                          type="text"
                          class="form-control"
                        />
                      </div>

                      <div class="form-group col-md-3">
                        <label> <span class="required">*</span> Cidade: </label>
                        <input
                          v-model="entity.city"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <!-- Status -->
                      <div class="form-group col-md-4">
                        <label> <span class="required">*</span> Status: </label>
                        <select v-model="entity.status" class="form-control">
                          <option :value="1">Ativo</option>
                          <option :value="0">Inativo</option>
                        </select>
                      </div>
                      <div class="form-group col-md-2 mt-2">
                        <div class="custom-control custom-switch">
                          <input
                            autocomplete="new-password"
                            v-model="entity.flag_record"
                            placeholder=""
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitch1"
                          />
                          <label
                            class="custom-control-label"
                            for="customSwitch1"
                            >Ficha via externa"</label
                          >
                        </div>
                      </div>
                      <div class="form-group col-md-2 mt-2">
                        <div class="custom-control custom-switch">
                          <input
                            autocomplete="new-password"
                            v-model="entity.alert"
                            placeholder=""
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitch2"
                          />
                          <label
                            class="custom-control-label"
                            for="customSwitch2"
                            >Alerta de AVC</label
                          >
                        </div>
                      </div>
                    </div>

                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <router-link to="/centrals" class="btn btn-back mr-1">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  data() {
    return {
      entity: {
        name: "",
        address: "",
        neighborhood: "",
        complement: "",
        cep: "",
        reference_point: "",
        phone: "",
        cnes: "",
        status: "1",
        number: "",
        city: "",
        uf: "",
        flag_record: 0,
        alert: 0,
      },
    };
  },
  computed: {},
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("name", self.entity.name);
      fd.append("fantasy_name", self.entity.fantasy_name);
      fd.append("cnes", self.entity.cnes);
      fd.append("email", self.entity.email);
      fd.append("cnpj", self.entity.cnpj);
      fd.append("telphone", self.entity.telphone ? self.entity.telphone : "");
      fd.append("celphone", self.entity.celphone ? self.entity.celphone : "");
      fd.append("cep", self.entity.cep);
      fd.append("street", self.entity.street);
      fd.append("number", self.entity.number);
      fd.append(
        "complement",
        self.entity.complement ? self.entity.complement : ""
      );
      fd.append("neighborhood", self.entity.neighborhood);
      fd.append("city", self.entity.city);
      fd.append("uf", self.entity.uf);
      fd.append("status", self.entity.status ? 1 : 0);
      fd.append("flag_record", self.entity.flag_record ? 1 : 0);
      fd.append("alert", self.entity.alert ? 1 : 0);

      fd.append("_method", "POST");

      if (self.entity.id) {
        fd.append("id", self.entity.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "centrals";

      let fd = self.makeFormData();

      if (self.entity.id) {
        self.entity._method = "PUT";
        api += "/" + self.entity.id;
      }

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/centrals");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEntity: function (id) {
      const self = this;
      const api = self.$store.state.api + "centrals/" + id;

      axios
        .get(api)
        .then((response) => {
          self.entity = response.data.data[0];
          self.entity.flag_record = self.entity.flag_record == "0" ? 0 : 1;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(self.entity.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + self.entity.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputnumber").focus();
              self.naoLocalizado = true;
              return;
            }

            self.entity.street = endereco.logradouro;
            self.entity.neighborhood = endereco.bairro;
            self.entity.complement = endereco.complemento;
            self.entity.uf = endereco.uf;
            self.entity.city = endereco.localidade;

            $("#inputnumber").focus();
          }
        );
      }
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    console.log(id);
    if (id) {
      self.getEntity(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>